/**
 * @typedef {Object} DecodedToken
 * @property {string} id
 * @property {string} name
 * @property {string} email
 * @property {string} image
 * @property {string} language
 * @property {string} lastname
 * @property {string} sessionId
 * @property {Object} verification
 * @property {boolean} verification.documents
 * @property {boolean} verification.email
 * @property {boolean} verification.phone
 * @property {boolean} verification.profile
 * @property {boolean} verification.terms
 */

/**
 * @typedef {Object} LegacySessionCookie
 * @property {string} name
 * @property {string} email
 * @property {string} sessionId
 * @property {boolean} logged
 * @property {string} imgSmall
 * @property {string} userId
 * @property {number} veicoliPubblicati
 */

/**
 * @typedef {Object} UserInterface
 * @property {string} id
 * @property {string} name
 * @property {string} email
 * @property {string} image
 * @property {string} locale
 * @property {string} lastname
 * @property {string} sessionId
 * @property {Object} verification
 * @property {boolean} verification.documents
 * @property {boolean} verification.email
 * @property {boolean} verification.phone
 * @property {boolean} verification.profile
 * @property {boolean} verification.terms
 */

export class User {
  /**
   * @param {string} id
   * @param {string} name
   * @param {string} email
   * @param {string} image
   * @param {string} locale
   * @param {string} lastname
   * @param {string} sessionId
   * @param {Object} verification
   * @param {string} abUuid
   */
  constructor(id, name, email, image, locale, lastname, sessionId, verification, abUuid) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.image = image;
    this.locale = locale;
    this.lastname = lastname;
    this.sessionId = sessionId;
    this.verification = verification;
    this.abUuid = abUuid || null;
  }

  /**
   * @param {DecodedToken} token
   * @returns {User}
   */
  static fromDecodedToken(token) {
    // Decodifica il campo image se è Base64
    let decodedImage = token.image;
    if (token.image && typeof token.image === 'string') {
      try {
        // Verifica se sembra essere Base64 (senza controlli rigidi per essere flessibili)
        if (token.image.length > 0 && !token.image.startsWith('http')) {
          // Tenta di decodificare da Base64
          decodedImage = atob(token.image);
        }
      } catch (error) {
        console.warn('Failed to decode image from Base64, using original value:', error);
        decodedImage = token.image;
      }
    }

    return new User(
      token.id,
      token.name,
      token.email,
      decodedImage,
      token.language,
      token.lastname,
      token.sessionId,
      token.verification,
      token.abUuid
    );
  }
}